import React, { useState } from 'react'
import { Flex } from '../../Components/Common/Flex'
import { Card } from '../../Components/Common/Card'
import { Button } from '../../Components/Common/Button'
import { Text } from '../../Components/Common/Text'
import { Document, Page, pdfjs } from 'react-pdf'

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

export const DocViewer = ({ pageNumber: [pageNumber, setPageNumber], doc, pdfDimensions: [pdfDimensions, setPdfDimensions] }) => {
  const [numPagesState, setNumPages] = useState(1)

  const onDocumentLoadSuccess = async (pdf) => {
    const { numPages } = pdf
    setNumPages(numPages)
    const pageObj = await pdf.getPage(1)
    const pageHeight = pageObj.view[3]
    const pageWidth = pageObj.view[2]
    setPdfDimensions({ width: pageWidth, height: pageHeight })
  }

  return (
    <Flex>
      <Card style={{ padding: 10, width: pdfDimensions.width, height: 65, borderRadius: 30 }}>
        <Flex row jb style={{ height: 45 }}>
          <Button onClick={() => (pageNumber - 1) && setPageNumber(pageNumber - 1)} label='Indietro' allowMultipleClick />
          <Text value={`Pagina ${pageNumber} di ${numPagesState}`} />
          <Button onClick={() => pageNumber !== numPagesState && setPageNumber(pageNumber + 1)} label='Avanti' allowMultipleClick />
        </Flex>
      </Card>
      <Document className='marginDocumentPDF' onLoadSuccess={onDocumentLoadSuccess} file={doc.documentUrl}>
        <Page height={pdfDimensions.height} width={pdfDimensions.width} pageNumber={pageNumber} renderTextLayer={false} renderAnnotationLayer={false} />
      </Document>
    </Flex>
  )
}
